export default __webpack_public_path__ + "static/media/TERMINAL_ICON_12.23e355dd.svg";